import { Citizenship } from 'shell/models/person/citizenship';
import { FamilyCoexistence } from 'shell/models/person/family';
import { SubjectAttributes } from 'shell/models/person/subject-attributes';
import { Generality } from 'shell/models/person/generality';
import {
  ControlData,
  RequestSubscriptionBirth,
} from 'subscription/models/request-subscription-birth';
import {
  transformAllegati,
  transformDatiControlloAire,
  transformFamiglia,
  transformGeneralita1001,
  transformLegameSoggetto,
  transformMaternita,
  transformResidenzaEstera,
  transformerPaternita,
} from './common-request-transformer';
import { transformerAttoNascitaFamily } from './birthday-document.transformer';
import { SubscriptionGainCitizenshipFormVM } from 'subscription/view-models/subscription-gain-citizenship';

/**
 * Transforms a SubscriptionGainCitizenshipFormVM into a RequestSubscriptionBirth object.
 * @param {SubscriptionGainCitizenshipFormVM} values
 * @returns {RequestSubscriptionBirth}
 */
export const transformerRequestSubscriptionGainCitizenshipAireData = (
  values: SubscriptionGainCitizenshipFormVM
): RequestSubscriptionBirth => {
  const attoNascita = transformerAttoNascitaFamily(values.birthdayDocument);

  const hasCitizenship =
    !!values.citizenship?.state || !!values.citizenship?.note || !!values.citizenship?.validity;

  const altraCittadinanza: Array<Citizenship> | undefined = hasCitizenship
    ? [
        {
          dataValidita: values.citizenship?.validity
            ? values.citizenship?.validity?.toFormat('yyyy-MM-dd')
            : undefined,
          codiceStato: values.citizenship?.state?.id || undefined,
          descrizioneStato: values.citizenship?.state?.value || undefined,
          noteStato: values.citizenship?.note || undefined,
        },
      ]
    : undefined;

  const paternita = transformerPaternita(values.fatherhood);

  const maternita = transformMaternita(values.motherhood);

  const famiglia: FamilyCoexistence | undefined = values.familyCoexistence
    ? transformFamiglia(values.familyCoexistence)
    : undefined;

  const legameSoggetto = values.familyCoexistence
    ? transformLegameSoggetto(values.familyCoexistence)
    : undefined;

  const datiControllo: ControlData = transformDatiControlloAire(values.editDataControl);

  const generalitaA002: {
    attributiSoggetto?: SubjectAttributes;
    generalita: Generality;
    statoCivile?: { statoCivile?: string };
  } = transformGeneralita1001(values.generality, values.civilStatus);

  const residenzaEstera = transformResidenzaEstera(values.addressForeign);

  const allegati = transformAllegati(values.document);

  return {
    testataRichiesta: {
      dataDecorrenza: values.editDataControl?.dateValidity
        ? values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd')
        : undefined,
    },
    attoNascitaANPR: attoNascita || undefined,
    altraCittadinanza,
    cittadinanza: values.oldCitizenship,
    paternita,
    maternita,
    famiglia: {
      famiglia,
      legameSoggetto,
    },
    datiControllo,
    generalitaA002,
    residenzaEstera,
    allegati,
  };
};
